import React from 'react';
import { AllQuizzQuery } from 'graphql/generated/graphql';
import { ElevesDashboardProf } from 'types/classe/maClasse';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import { MobileTabLineBox } from 'components/atoms/Texts/MobileTabLineBox';
import { displayQuizDate } from 'helpers/table/quiz/displayQuiz';
import { ButtonWithText } from '../../../../atoms/Buttons/ButtonWithText';
import pages from '../../../../../routes/pages';
import { getGoToPage } from '../../../../../helpers/page/goToPage';
import { useHistory } from 'react-router-dom';
import { SuiviQuiz } from '../../../../organisms/Table/TableData/TableDataLineQuizProf';
import { useSelector } from 'react-redux';
import { AppState } from '../../../../../store/reducers';

export interface MobileTabLineQuizProps {
  eleves?: ElevesDashboardProf[];
  data: AllQuizzQuery;
}

export const MobileTabLineQuiz = ({ eleves, data }: MobileTabLineQuizProps) => {
  const history = useHistory();
  const classeId = useSelector((state: AppState) => state.user.classe.id);
  return (
    <>
      {data.availableQuiz?.map((quiz, i) => (
        <FeatureContainer key={i} padding="mobileTab">
          <MobileTabLineBox
            texts={[
              { text: quiz.name, style: 'bold' },
              {
                text: displayQuizDate(quiz.debut, quiz.fin),
                style: 'bottomRegular'
              }
            ]}
          />
          <SuiviQuiz quizId={quiz.id} users={eleves} />
          <ButtonWithText
            variant="mobileTab"
            onClick={() =>
              getGoToPage(history)(pages.RECAP_QUIZ_CLASSE_PAGE.path)({
                id: quiz.id,
                classeId: classeId
              })
            }
            icon={'Info'}
            content="Voir les réponses"
          />
        </FeatureContainer>
      ))}
    </>
  );
};
